import React, { useContext, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
    DateField, Icon, Loader, Accordion, Chevron
} from '@jutro/components';
import { TranslatorContext, FormattedMessage } from '@jutro/locale';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import HomeCoverageTable from '../HomeCoverageTable/HomeCoverageTable';
import metadata from './PolicyDwellingInfo.metadata.json5';
import messages from './PolicyDwellingInfo.messages';
import styles from './PolicyDwellingInfo.module.scss';import PolicyScheduleItemsComponent
from '../../PolicyScheduleItemsComponent/PolicyScheduleItemsComponent';

const getFormattedInfo = (message, key, value) => {
    return (
        <FormattedMessage
            {...message}
            values={{
                [key]: value
            }}
        />
    );
};

const translateYesNo = (keyObject, translator) => {
    const object = _.cloneDeep(keyObject);
    const appendingYear = (obj, key) => {
        let result = '';
        const mappingYear = {
            heatingUpgraded: 'heatingUpgradeYear',
            plumbingUpgraded: 'plumbingUpgradeYear',
            wiringUpgraded: 'wiringUpgradeYear',
            roofUpgraded: 'roofUpgradeYear'
        };
        const getDisplayYearKey = mappingYear[key];
        if (getDisplayYearKey && obj[key]) {
            result = `(${obj[getDisplayYearKey]})`;
        }
        return result;
    };
    if (!_.isEmpty(object)) {
        _.map(object, (value, key) => {
            if (typeof value === 'boolean') {
                object[key] = `${translator(
                    value ? messages.infoYes : messages.infoNo
                )} ${appendingYear(object, key)}`;
            }
        });
    }
    return object;
};

const checkValueisTrue = (val) => {
    return val === true || (val && val.indexOf('Yes')) ? true : false;
}

const convertYesNo = (boolObj, translator) => {
    let val = '-'
    if(boolObj !== undefined){
        val = `${translator(boolObj ? messages.infoYes : messages.infoNo)}`;
    }
    return val;
}

const getAddress = (address) => {
    //const dwellingAddress = address.locationName.substring(address.locationName.indexOf(':') + 1, address.locationName.length).trim()
    //return `${dwellingAddress}`
   const addressline2 = address.addressline2 ? `, ${address.addressline2}` : '';
   return `${address.addressLine1} ${addressline2}, ${address.city}, ${address.state} , ${address.postalCode}`;
};

//Pass the location on the 2nd parameter
const getHeaderSection = (title, title1) => {
    return (isOpen) => (
        <React.Fragment>
            <Chevron isOpen={isOpen} align="right" className={styles.chevronStyle} />
            <h2 className={`${styles.customAccordion_cardTitle} `}>{title}</h2>
            <h3 className={`${styles.customAccordion_cardTitle2} ${styles.gwOverrideDefaultMargin}`}>{title1}</h3>
        </React.Fragment>
    );
};

function PolicyDwellingInfo(props) {
    const translator = useContext(TranslatorContext);
    const [openItems, setOpenItems] = useState([]);
    const [openCovItems, setOpenCovItems] = useState([]);
    const updateCoverages = (dwellingCoverages) => {
        const dwellingDTO = _.cloneDeep(dwellingCoverages);
            const coverages = dwellingDTO.coverageDTOs;
            const allCoverages = {
                sectionICoverages: [],
                sectionIICoverages: [],
                additionalLiabilityCoverages: [],
                additionalPropertyCoverages: [],
                scheduledItems: [],
                //endorsements: [],
                optionalCoverages: [],
                combinedManOptCoverages: [],
                discounts: [],
                addlInterests: [],
                coverages: []
            };
           /*  coverages.forEach((coverage) => {
                const cov = coverage;

                switch (cov.categoryCodeIdentifier) {
                    case 'HOPSectionICovCat':
                    case 'HODW_SectionI_HOE':
                        allCoverages.sectionICoverages.push(cov);
                        allCoverages.combinedManOptCoverages.push(cov);
                        break;
                    case 'HOPSectionIICovCat':
                    case 'HODW_SectionII_HOE':
                        allCoverages.sectionIICoverages.push(cov);
                        allCoverages.combinedManOptCoverages.push(cov);
                        break;
                    case 'HO_Endorsement_EY':
                        allCoverages.endorsements.push(cov);
                        break;
                    case 'HOPOptionalCovCat':
                        allCoverages.optionalCoverages.push(cov);
                        allCoverages.combinedManOptCoverages.push(cov);
                        break;
                    case 'HOPAdditionalCovCat':
                    case 'HOLI_Additional_HOE':
                        allCoverages.additionalLiabilityCoverages.push(cov);
                        break;
                    case 'HOPPCAdditionalCovCat':
                    case 'HODW_Additional_HOE':
                        allCoverages.additionalPropertyCoverages.push(cov);
                        break;
                    case 'HOPScheduledItemCovCat':
                    case 'HODW_SchedulesCov_HOE':
                        if (cov.specialLimits) {
                            cov.specialLimits.forEach((coverageItem) => {
                                allCoverages.scheduledItems.push(coverageItem);
                            });
                        } else if (cov.scheduledProperty) {
                            cov.scheduledProperty.forEach((coverageItem) => {
                                allCoverages.scheduledItems.push(coverageItem);
                            });
                        }
                        break;
                    default:
                        break;
                }
            }); */
            allCoverages.coverages = dwellingDTO.coverageDTOs ? dwellingDTO.coverageDTOs : dwellingDTO.coverages ;
            allCoverages.addlInterests = dwellingDTO.additionalInterests;
            allCoverages.discounts = dwellingDTO.discounts;
            allCoverages.endorsements = dwellingDTO.endorsements? dwellingDTO.endorsements : '';
            allCoverages.scheduledItems = allCoverages.coverages.filter((cov)=>{ return !_.isEmpty(cov.scheduledItems)})
            return allCoverages;
    };

    const getHomeOwnersData = useCallback(() => {
        const homeOwnersData = _.cloneDeep(props.value);


        homeOwnersData.dwellingDTO.forEach((dwellingDTO, index) => {
            if (homeOwnersData.dwellingDTO[index].homeDetails && !_.isEmpty(homeOwnersData.dwellingDTO[index].homeDetails)) {
                    homeOwnersData.dwellingDTO[index].homeDetails = translateYesNo(
                        homeOwnersData.dwellingDTO[index].homeDetails,
                        translator
                    );
                    _.set(
                        homeOwnersData,
                        'dwellingDTO[${index}].homeDetails.distanceToFireHydrant',
                        getFormattedInfo(
                            messages.FeetToFireHydrant,
                            'distance',
                            homeOwnersData.dwellingDTO[index].homeDetails.distanceToFireHydrant
                        )
                    );
                    _.set(
                        homeOwnersData,
                        'dwellingDTO[0].homeDetails.distanceToFireStation',
                        getFormattedInfo(
                            messages.MilesToFireStation,
                            'miles',
                            homeOwnersData.dwellingDTO[index].homeDetails.distanceToFireStation
                        )
                    );
                }
                if (!_.isEmpty(homeOwnersData.dwellingDTO[index].constructionDetails)) {
                    homeOwnersData.dwellingDTO[index].constructionDetails = translateYesNo(
                        homeOwnersData.dwellingDTO[index].constructionDetails,
                        translator
                    );
                }
                if (!_.isEmpty(homeOwnersData.dwellingDTO[index].miscDetails)) {
                    homeOwnersData.dwellingDTO[index].miscDetails = translateYesNo(
                        homeOwnersData.dwellingDTO[index].miscDetails,
                        translator
                    );
                }
                if (_.isEmpty(homeOwnersData.dwellingDTO[index].mortgageeDetailsDTO)) {
                    homeOwnersData.dwellingDTO[index].mortgageeDetailsDTO = [];
                }
                homeOwnersData.dwellingDTO[index].allCoverages = updateCoverages(dwellingDTO);
        });
        return homeOwnersData;
    }, [props, translator]);

    const homeOwnersData = getHomeOwnersData();
    const lobType = props.lobType;

    if (_.isEmpty(homeOwnersData)) {
        return null;
    }

    //Show/Hide package details code -- Start--
    const toggleShowHide = useCallback(
        (item) => {
            const openedItem = _.clone(openItems);
            const index = _.indexOf(openedItem, item);
            if (index === -1) {
                openedItem.push(item);
                setOpenItems(openedItem);
            } else {
                setOpenItems(_.slice(openedItem, index, 0));
            }
        },
        [openItems]
    );

    const toggleShowHideCov = useCallback(
        (item) => {
            const openedItem = _.clone(openCovItems);
            const index = _.indexOf(openedItem, item);
            if (index === -1) {
                openedItem.push(item);
                setOpenCovItems(openedItem);
            } else {
                setOpenCovItems(_.slice(openedItem, index, 0));
            }
        },
        [openCovItems]
    );

    const getCellBuildingName = (index, bname) => {
        let buildingname = `Building ${index + 1}`;
        if (bname) {
            buildingname += `: ${bname}`;
        }
        return (
            <span>{buildingname}</span>
        );
    };

    const generateScheduleItemDetails = useCallback((packageDTO) => {
         let overrides = []
         if(!_.isUndefined(packageDTO.coverages) && !_.isEmpty(packageDTO.coverages.filter((cov)=>{ return !_.isEmpty(cov.scheduledItems)}))){
             overrides = packageDTO.coverages.filter((cov)=>{ return !_.isEmpty(cov.scheduledItems)}).map((cov, index) => {
                return {
                   [`scheduledItemHeading${index}`]: {
                       content: cov.name
                   },
                   [`scheduledItemsTableContainer${index}`]: {
                       scheduledItems: cov.scheduledItems,
                       showSchedule: true
                   },
                };
            });
         }

         return Object.assign({}, ...overrides);
     }, []);

     const generatePackageDetails = useCallback(() => {
         const _lobType = props.lobType

         const homeOwnersData = _.cloneDeep(props.value);
         const overrides = homeOwnersData.dwellingDTO.map((packageDTO, index) => {
            //var title = packageDTO.address.displayName;
             return {
                 [`dwellingPackageDetailsContainer${index}`]: {
                    //header: getHeaderSection('Property Information', title)
                },
               /*  [`homeAddressId${index}`]: {
                    content: getAddress(packageDTO.address)
                }, */
                 [`showContentToggleLink${index}`]: {
                     onClick: () => toggleShowHide(index)
                 },
                 [`showCoverageContentToggleLink${index}`]:{
                    onClick: () => toggleShowHideCov(index)
                 },
                 [`contentDetailToggle${index}`]: {
                     icon: _.includes(openItems, index) ? 'caret-up' : 'caret-down',
                     message: _.includes(openItems, index)
                         ? translator(messages.hideBuildingDetails)
                         : translator(messages.showBuildingDetails)
                 },
                 [`coverageContentDetailToggle${index}`]: {
                    visible: (!_.isUndefined(packageDTO.coverages) && packageDTO.coverages.length != 0) ||
                        (!_.isUndefined(packageDTO.coverageDTOs) && packageDTO.coverageDTOs.length != 0),
                    icon: _.includes(openCovItems, index) ? 'caret-up' : 'caret-down',
                    message: _.includes(openCovItems, index)
                        ? translator(messages.hideCoverages)
                        : translator(messages.showCoverages)
                 },
                 [`hoDetailsContainer${index}`]: {
                     visible: _.includes(openItems, index)
                 },
                 [`coverageContentToggleContainer${index}`]: {
                     visible: _.includes(openCovItems, index)
                 },
                 [`structureTypeID${index}`]: {
                    value: translator
                    ({
                        id: `typekey.StructureType_EY.${packageDTO.structureType}`,
                        defaultMessage: "Structure Type"
                    })
                 },
                 [`packageID${index}`]: {
                    value: packageDTO.coveragePart ? translator
                        ({
                            id: `typekey.CoveragePartType.${packageDTO.coveragePart}`,
                            defaultMessage: "Package Type"
                        })  + " " +translator({
                            id: `typekey.HOPCoverageForm.${packageDTO.coverageForm}`,
                            defaultMessage: "Coverage From"
                        }) : '-'
                 },
                 /* [`occupancyTypeID${index}`]: {
                     value: `${packageDTO.primaryType}` === 'true' ? translator
                         (messages.primary) : '-'
                 },  */
                 [`homeAddressId${index}`]: {
                    content: lobType ? getCellBuildingName(index, packageDTO.name) : getAddress(packageDTO.address)
                },
                [`packageIDColumn${index}`]: {
                    visible: (lobType === undefined)
                },
                [`noOfTenantsColumn${index}`]: {
                    visible: (lobType === undefined)
                },
                [`CoveragesDetailsHeader${index}`]: {
                    visible: !_.isUndefined(packageDTO.coverages) && packageDTO.coverages.length != 0,
                    content: lobType ? translator(messages.BuildingCoverages) : translator(messages.Coverages)
                },
                 [`isBasementFinished${index}`]: {
                    value: convertYesNo(packageDTO.isBasementFinished, translator)
                },
                [`RoofUpdateTypeColumn${index}` ]: {
                    visible: packageDTO.constructionDetails && checkValueisTrue(packageDTO.constructionDetails.roofUpgraded)
                },
                [`WiringUpdateTypeColumn${index}` ]: {
                    visible: packageDTO.constructionDetails && checkValueisTrue(packageDTO.constructionDetails.wiringUpgraded)
                },
                [`PlumbingUpdateTypeColumn${index}` ]: {
                    visible: packageDTO.constructionDetails && checkValueisTrue(packageDTO.constructionDetails.plumbingUpgraded)
                },
                [`scheduledItemsContainer${index}` ]: {
                   //visible: !_.isUndefined(packageDTO.coverages) && !_.isEmpty(packageDTO.coverages.filter((cov)=>{ return !_.isEmpty(cov.scheduledItems)}))
                    visible: true
                },
                [`repeatScheduletab${index}` ]: {
                    data: (!_.isUndefined(packageDTO.coverages) && !_.isEmpty(packageDTO.coverages.filter((cov)=>{ return !_.isEmpty(cov.scheduledItems)})))
                    ? packageDTO.coverages.filter((cov)=>{ return !_.isEmpty(cov.scheduledItems)})
                    : []
                 },
                 [`coveragesTableContainer${index}`]:{
                    isCommercialProperty: (_lobType == "Commercial Property") ? true : false
                 },
                /* [`RoofUpdateTypeColumn${index}` ]: {
                    visible: packageDTO.constructionDetails.heatingUpgraded
                },  */
                ...generateScheduleItemDetails(packageDTO)
             };
         });

         return Object.assign({}, ...overrides);
     }, [homeOwnersData, openItems, toggleShowHide, props.value, translator]);
    //Show/Hide package details code -- End--

    const overrides = {
        /* homeDetailsSeparator: {
            visible: !_.isEmpty(homeOwnersData.mortgageeDetailsDTO)
        }, */
        ...generatePackageDetails()
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            homecoveragetablecomponent: HomeCoverageTable,
            policyScheduleItemsComponent: PolicyScheduleItemsComponent
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={homeOwnersData}
            overrideProps={overrides}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
        />
    );
}

PolicyDwellingInfo.propTypes = {
    value: PropTypes.shape({}).isRequired
};

export default PolicyDwellingInfo;
